export default {
  /**
   * 数组相加
   * @param oa oldArry
   * @param na newArry
   */
  arryAdd: function (oa, na) {
    if (na) {
      na.forEach(function (v) {
        oa.push(v)
      });
    }
  },
//判断是否为数字
  isNumber(str) {
    return !isNaN(str);
  },

  isInteger(str) {
    return this.isNumber(str) && str % 1 === 0;
  },

  //判断是否为Url
  isUrl(url) {
    url = typeof url !== 'string' ? url + '' : url;
    return url.startsWith("http");
  },

  /**
   * 是否数字，字母，符号
   * @param str
   * @returns {boolean}
   */
  isNumberLetterSymbol(str) {
    return /^[a-zA-Z0-9!@#$%^&*()_+|{}?><\-\]\\[\/]*$/g.test(str);
  },
  getAdvPosition(type) {
    switch (type) {
      case 1:
        return "首页"
      case 2:
        return "导航"
      case 3:
        return "商品列表"
      case 4:
        return "购买成功页"
      case 5:
        return "新闻详情广告位"
      case 6:
        return "新闻列表轮播图"
      case 7:
        return "H5图标"
      case 8:
        return "app"
      case 9:
        return "第三方应用"
      case 22:
        return "首页推荐活动"
    }
  },
  getAdvType(position) {
    switch (position) {
      case 1:
        return "banner"
      case 2:
        return "图标"
      case 3:
        return "图片"
      case 4:
        return "文字"

    }
  },


  /**
   * 是否汉字、数字、字母
   * @param str
   * @returns {boolean}
   */
  isChineseNumberLetter(str) {
    return !/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g.test(str);
  },

  /**
   * 合并两个数组并去重
   * @param arr1
   * @param arr2
   * @param type add 相同时只留下一个，remove 相同时删除
   * @returns {*}
   */
  mergeArray(arr1, arr2, type = 'add') {
    switch (type) {
      case 'add':
        for (let i = 0; i < arr1.length; i++) {
          for (let j = 0; j < arr2.length; j++) {
            if (arr1[i] === arr2[j]) {
              arr1.splice(i, 1);
            }
          }
        }
        for (let i = 0; i < arr2.length; i++) {
          arr1.push(arr2[i]);
        }
        return arr1;
        break;
      case 'remove':
        const tempArray1 = [];
        const tempArray2 = [];

        for (let i = 0; i < arr2.length; i++) {
          tempArray1[arr2[i]] = true;
        }

        for (let i = 0; i < arr1.length; i++) {
          if (!tempArray1[arr1[i]]) {
            tempArray2.push(arr1[i]);
          }
        }
        return tempArray2;
        break;
    }
  },

  /**
   * 数组去重
   * @param arr
   * @returns {Array}
   */
  uniqArray(arr) {
    return Array.from(new Set(arr));
  },

  yestardayTimeDate() {
    let day = new Date();
    return day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
  },

  isMobilePhone(phone) {
    let exp = /^1[3-9][0-9]\d{8}$/;
    return exp.test(phone)
  },
  getRentWay(rentWay) {
    switch (rentWay) {
      case 10:
        return '小时';
      case 20:
        return '天';
      case 30:
        return '夜';
      case 40:
        return '周';
      default:
        break;
    }
  },
  getPurchasePrice(item) {
    switch (item.rentWay) {
      case 10:
        return item.rentalHourPurchasePrice * item.productQuantity;
      case 20:
        return item.rentalDayPurchasePrice * item.productQuantity;
      case 30:
        return item.rentalNightPurchasePrice * item.productQuantity;
      case 40:
        return item.rentalWeekPurchasePrice * item.productQuantity;
      default:
        break;
    }
  },
  objectToArray(obj) {
    // 使用Object.entries()将对象转换为键值对数组
    return Object.entries(obj).map(([id, name]) => ({ id, name }));
  }
}



// WEBPACK FOOTER //
// ./src/utility/utils.js